import { handleCatchError } from 'utils/CatchHandler';
import { GET_API_ENDPOINTS } from './Endpoints';
import { axiosInstanceLive } from 'instance/Axios';

const authenticationCommonGetRequest = async (apiEndPoint) => {
    const token = localStorage.getItem('token');
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    try {
        const response = await axiosInstanceLive.get(apiEndPoint, {
            headers
        });
        return response;
    } catch (error) {
        handleCatchError(error);
        return error;
    }
};

export const authConnect = async () => {
    try {
        const response = await authenticationCommonGetRequest(GET_API_ENDPOINTS.authConnect);
        return response;
    } catch (error) {
        return error;
    }
};
